<div class="d-flex flex-column justify-content-center align-content-center p-4">
  <div class="message-container">
    @if (data.showCloseIcon) {
      <div class="d-flex justify-content-end">
        <img class="d-flex justify-content-end cursor-pointer close-btn"
          [mat-dialog-close]="{close:true}"
          src="assets/svg/close.svg"
          alt/>
        </div>
      }
      @if (data.isSuccess) {
        <div class="icon-success d-flex justify-content-center"></div>
      }
      @if (data.isFailure) {
        <div class="icon-failure d-flex justify-content-center"></div>
      }
      <div class="message-title d-flex justify-content-center mt-4 mb-3 fs-18">
        {{data.msg}}
      </div>
      @if (data.sub_msg) {
        <div class="message d-flex justify-content-center mb-4 fs-18">
          {{data.sub_msg}}
        </div>
      }
    </div>
    <div class="d-flex align-content-center justify-content-center">
      @if (!data.isConfirm) {
        <button mat-button
          (click)="closeModal()"
          class="mr-2 button-primary mat-button-base p-0">
          OK
        </button>
      } @else {
        <button mat-button
          (click)="closeModal(data?.confirmBtnInfo?.accept.returnValue || true)"
          class="mr-2 button-primary mat-button-base p-0">
          {{data?.confirmBtnInfo?.accept.text || 'Yes'}}
        </button>
        <button mat-button
          (click)="closeModal(data?.confirmBtnInfo?.reject.returnValue || false)"
          class="mr-2 button-primary mat-button-base p-0">
          {{data?.confirmBtnInfo?.reject.text || 'No'}}
        </button>
      }
    </div>
  </div>
